import { createContext } from 'react';

const roleContext = createContext();

export default roleContext;
